import { useUpdateData } from 'shared/hooks/use-update-data'
import { CourseId } from '../../types/course-interface'
import { COURSE_API } from '../api/course-curriculum-api'

export const useUpdateLectureData = (courseId: CourseId) => {
  return useUpdateData({ api: `${COURSE_API}/${courseId}/curriculum` })
}
